/**
 * Extracts the path and query parameters from a URL string.
 * Supports both absolute (http://...) and relative URLs.
 *
 * @param raw - URL to parse, e.g. '/users?page=2' or 'https://site.com/users?page=2'
 * @returns { path, queryParams } or null if raw is empty
 */
export function parseRelativeUrl(raw: string): { path: string; queryParams: Record<string, string> } | null {
  if (!raw) return null;

  const url = /(https?:\/\/)/i.test(raw) ? new URL(raw).pathname + new URL(raw).search : raw;
  const [path, qs] = url.split('?');
  const queryParams = qs
    ? Object.fromEntries(
        qs.split('&').map((pair) => {
          const [key, ...vals] = pair.split('=');
          return [key, vals.join('=')];
        })
      )
    : {};

  return { path, queryParams };
}
